import { global } from '@/config/global'

/**
 * 生成UTC时间字符串
 * @param {*} now
 */
export const $timestampUTCStr = (now) => {
  let year = now.getUTCFullYear()
  let month = (now.getUTCMonth() + 1).toString()
  let day = (now.getUTCDate()).toString()
  let hour = (now.getUTCHours()).toString()
  let minute = (now.getUTCMinutes()).toString()
  let second = (now.getUTCSeconds()).toString()

  if (month.length === 1) {
    month = `0${month}`
  }

  if (day.length === 1) {
    day = `0${day}`
  }

  if (hour.length === 1) {
    hour = `0${hour}`
  }

  if (minute.length === 1) {
    minute = `0${minute}`
  }

  if (second.length === 1) {
    second = `0${second}`
  }

  return `${year}-${month}-${day}T${hour}:${minute}:${second}Z`
}

/**
 * 生成时间字符串
 * @param {*} now
 */
export const $timestampLocalStr = (now) => {
  let year = now.getFullYear()
  let month = (now.getMonth() + 1).toString()
  let day = (now.getDate()).toString()
  let hour = (now.getHours()).toString()
  let minute = (now.getMinutes()).toString()
  let second = (now.getSeconds()).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  if (day.length === 1) {
    day = '0' + day
  }
  if (hour.length === 1) {
    hour = '0' + hour
  }
  if (minute.length === 1) {
    minute = '0' + minute
  }
  if (second.length === 1) {
    second = '0' + second
  }

  return year + '.' + month + '.' + day + ' ' + hour + ':' + minute
}

export const $isInIos = () => {
  if (navigator.platform) {
    // 解决IOS-13以后版本问题
    return /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  } else {
    var u = navigator.userAgent.toLocaleLowerCase()
    if (u.indexOf('iphone') > -1 || u.indexOf('ipad') > -1) {
      return true
    }
  }
  return false
  // return true
}

/**
 * IOS阻止双指放大事件
 */
export const $preventDefaultIos = () => {
  // 阻止双击放大
  var lastTouchEnd = 0
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)

  // 阻止双指放大
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}

/**
 * 一维数组转换成二维数组，数组长度为N
 * @param {*} num 二维数组长度
 * @param {*} arr 被转换的一维数组
 */
export const $arrTrans = (num, arr) => { // 一维数组转换为二维数组
  var iconsArr = [] // 声明数组
  arr.forEach(function (item, index) {
    var page = Math.floor(index / num) // 计算该元素为第几个素组内
    if (!iconsArr[page]) { // 判断是否存在
      iconsArr[page] = []
    }
    iconsArr[page].push(item)
  })
  return iconsArr
}

/**
 * 防抖动函数
 * @param {*} fn 需防抖动函数
 */
export const $debounce = (fn) => {
  let timeout = null // 创建一个标记用来存放定时器的返回值
  return function () {
    clearTimeout(timeout) // 每当用户输入的时候把前一个setTimeout clear 掉
    timeout = setTimeout(() => { // 然后又创建一个新的 setTimeout, 这样就能保证输入字符后的 interval间隔内如果还有字符输入的话，就不会执行 fn 函数
      fn.apply(this, arguments)
    }, 500)
  }
}
// 复制
export const $copyCode = (selector) => {
  var input = document.createElement('input')
  input.setAttribute('value', selector)
  document.querySelector('.activity-title').appendChild(input)
  input.setAttribute('readonly', 'readonly')
  input.select()
  document.execCommand('copy')
  document.querySelector('.activity-title').removeChild(input)
  setTimeout(() => {
    input.removeAttribute('readonly')
  }, 200)
}

/**
 * 根据flag从产品列表中查询出对应产品
 * 自动续费产品比较flag（eg：1Atuto && 服务端字段isAutoRenew）
 * @param {*} prodList Array
 * @param {*} flag String 1 1Auto
 * @returns 
 */
export const $findProdByFlag = (prodList, flag) => {
  if (!prodList) {
    return null
  }

  return prodList.find((prod) => {
    return flag.includes(global.AUTO_RENEW_FLAG) ? (`${prod.flag}${global.AUTO_RENEW_FLAG}` === String(flag) && prod.isAutoRenew) : (String(prod.flag) === String(flag) && !prod.isAutoRenew)
  })
}

/**
 * 是否在微信 QQ内置浏览器
 */
export const $isInWQ = () => {
  const ua = navigator.userAgent.toLocaleLowerCase()

  return ua.match(/MicroMessenger/i)=="micromessenger" || ua.match(/\bqq\b/i) == "qq";
}

/**
 * 判断两个时间戳是否在同一天内
 * 
 * @param {*} timestamp1 
 * @param {*} timestamp2 
 * @returns 
 */
export const $isSameDay = (timestamp1, timestamp2) => {
  const date1 = new Date(timestamp1);
  const date2 = new Date(timestamp2);

  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
}

/**
 * 获取url参数
 * 
 * @param {*} url 
 * @param {*} paramName 
 * @returns 
 */
export const $getUrlParam = (paramName) => {
  const searchParams = new URLSearchParams(location.href.split("?")[1]);
  return searchParams.get(paramName);
}

export const $isXunMengTu = () => {
  return $getUrlParam("appType") == 'xunmengtu'
}

/**
 * 数组为空或者每个元素都是""
 */
export const $isArrayEmptyOrAllElementsEmpty = (arr) => {
  // 检查数组是否为空
  if (!Array.isArray(arr) || arr.length === 0) {
    return true
  }
  
  // 检查数组中的每个元素是否都是空字符串
  return arr.every(element => element === '')
}

/**
 * 给定一个时间戳，并判断是否是今日范围内
 */
export const $isTimestampToday = (timestamp) => {
  // 获取当前时间
  const now = new Date()

  // 获取今天的开始时间（00:00:00）
  const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)

  // 获取今天的结束时间（23:59:59）
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999)

  // 将时间戳转换为Date对象
  const date = new Date(Number(timestamp))

  // 检查时间戳是否在今天的范围内
  return date >= startOfDay && date <= endOfDay
}
